import type {
	ParsedLayout,
	ParsedStructuredElementType,
	PeopleEntityElementType,
	PeopleEntityListElementType,
} from './types';

export type UniquePeopleEntity = {
	accountId: string;
	name?: string;
};

/**
 * Unique people entities from direct `people-entity` children of a `people-entity-list`,
 * in document order (skips strings and non-`people-entity` children).
 */
export function getUniquePeopleEntitiesFromList(
	list: PeopleEntityListElementType,
): UniquePeopleEntity[] {
	const listChildren = Array.isArray(list.children) ? list.children : [];
	const people: UniquePeopleEntity[] = [];
	const seen = new Set<string>();

	for (const child of listChildren) {
		if (typeof child === 'string') {
			continue;
		}

		const structured = child as ParsedStructuredElementType;
		if (structured.tag !== 'people-entity') {
			continue;
		}

		const attributes = (structured as PeopleEntityElementType).attributes;
		const accountId = attributes?.accountId?.trim();
		if (!accountId || seen.has(accountId)) {
			continue;
		}

		seen.add(accountId);
		people.push({ accountId, name: attributes?.name?.trim() || undefined });
	}

	return people;
}

/**
 * Unique trimmed `accountId`s from direct `people-entity` children of a `people-entity-list`.
 */
export function getUniquePeopleEntityAccountIdsFromList(
	list: PeopleEntityListElementType,
): string[] {
	return getUniquePeopleEntitiesFromList(list).map(({ accountId }) => accountId);
}

export const getFirstFoldableSectionIdx = (parsedAnswer: ParsedLayout): number => {
	let firstFoldableSectionIdx = -1;
	for (let i = 0; i < parsedAnswer.length; i++) {
		if (parsedAnswer[i].attributes?.folded === '1') {
			firstFoldableSectionIdx = i;
			break;
		}
	}

	return firstFoldableSectionIdx;
};
